// extracted by mini-css-extract-plugin
export default {"node":"lsf-node","node-minimal":"lsf-node-minimal","node-minimal__counter":"lsf-node-minimal__counter","node-minimal__icon":"lsf-node-minimal__icon","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630380658
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  